/* eslint-disable max-len */
import { VideoStatus } from 'common/enums';
import { useEffect } from 'react';
import { AllVideoProps } from 'networking/types/all-video-props';
import { VideoRow } from '../video-row';
import styles from './videos-queue.module.scss';

type VideosQueueProps = {
  videos: AllVideoProps[];
  vaultId: number;
  notifyVideoStatusChange: (videoId: number, newStatus: string) => void;
  videosInProgress: boolean;
  saveVideos: () => Promise<void>;
};

const VideosQueue: React.FC<VideosQueueProps> = ({
  videos,
  vaultId,
  notifyVideoStatusChange,
  videosInProgress,
  saveVideos,
}) => {
  const showVideosList = () => (
    <div className={styles.videosRowsContainer}>
      {videos.map((video: AllVideoProps) => (
        <VideoRow
          key={video.id}
          vaultId={vaultId}
          video={video}
          notifyVideoStatusChange={(id: number, newStatus: string) =>
            notifyVideoStatusChange(id, newStatus)
          }
        />
      ))}
    </div>
  );

  const handleSaveVideos = async () => {
    if (
      !videosInProgress &&
      videos.every((video) => video.status === VideoStatus.ready)
    ) {
      await saveVideos();
    }
  };

  useEffect(() => {
    // TODO: Handle upload errors
    handleSaveVideos();
  }, [videos]);

  return <div className={styles.queueContainer}>{showVideosList()}</div>;
};

export { VideosQueue };
